import {Color} from "three";
import * as THREE from "three";

function generateTexture() {

    const canvas = document.createElement('canvas');
    canvas.width = 2;
    canvas.height = 2;

    const context = canvas.getContext('2d');
    context.fillStyle = 'white';
    context.fillRect(0, 1, 2, 1);

    return canvas;

}

//const texture = new THREE.CanvasTexture( generateTexture() );

export const MATERIAL_PROPS_DB = [


    {
        materialName: "GlassMat",
        glass: true,
        glassMatFunc: (envMap) => {
            return new THREE.MeshPhysicalMaterial({
                name: `GlassMat-MPM`,
                color: new THREE.Color(0xffffff),
                emissive: new THREE.Color(0.20969663085937498, 0.21999999999999997, 0.21999999999999997),
                metalness: .01,
                roughness: 0,
                // alphaMap: texture,
                // alphaTest: 0.5,
                //envMap: envMap, //this.backgroundMap,
                envMapIntensity: .572,
                //depthWrite: false,
                transmission: 0, // use material.transmission for glass materials
                opacity: .1, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true,
                //ior: 1.5,
                //specularIntensity: 1,
                //specularColor: 0xffffff,
                side: THREE.DoubleSide,
                //alphaMap: texture,
                toneMapped: false,
            });
        },
    },
    {
        materialName: "wineGlass",
        glass: true,
        glassMatFunc: (envMap) => {
            return new THREE.MeshPhysicalMaterial({
                name: `wineGlass-MPM`,
                color: new THREE.Color(0xffffff),
                emissive: new THREE.Color(0.20969663085937498, 0.21999999999999997, 0.21999999999999997),
                metalness: .01,
                roughness: 0.001,
                clearcoat: 1.0,
                // alphaMap: texture,
                // alphaTest: 0.5,
                envMap: envMap, //this.backgroundMap,
                envMapIntensity: 4.91,
                //depthWrite: false,
                transmission: 1, // use material.transmission for glass materials
                opacity: .17, // set material.opacity to 1 when material.transmission is non-zero
                transparent: true,
                ior: 0.31,
                thickness: 1.46,
                specularIntensity: 1,
                //specularColor: 0xffffff,
                //  side: THREE.DoubleSide,
                //alphaMap: texture,
                toneMapped: false,
                wireframe: true,
            });
        },
    },


    {
        materialName:"FloorGroundMat",
        aOIntensity:0.2760865660626288,
        envMapIntensity:2.591767276147307,
        roughness: 0.5714034204700357,
        metalness: 1,
        toneMapped: 'Y',

    },

    {
        materialName:"FloorFirstMat",
        aOIntensity:0.2760865660626288,
        envMapIntensity:2.591767276147307,
        roughness:0.7233824379443335,
    },

    {
        materialName: "WallsGroundFloorMat",
        aOIntensity: 0.7519779528601696,
        envMapIntensity: 3.0,
        toneMapped: 'N',

    },
    {
        materialName: "WallsFirstFloorMat",
        aOIntensity: 0.7519779528601696,
        envMapIntensity: 1.5173270877471752,
        toneMapped: 'N',

    },

    {
        materialName: "WindowsFrameMat",
        aOIntensity: 0.1495481563013279,
        envMapIntensity: 5.117439732653664,
        toneMapped: 'Y',

    },

    {
        materialName: "CeilingGroundMat",
        aOIntensity: 0.6604582314388885,
        envMapIntensity: 0.9,
        toneMapped: 'N',

    },
    {
        materialName: "CeilingFirstMat",
        aOIntensity: 0.6604582314388885,
        envMapIntensity: 0.9,
        toneMapped: 'N',

    },

    {
        materialName: "SkirtingAllFloorsMat",
        aOIntensity: 0.34113943447791306,
        envMapIntensity:1.5,
        toneMapped: 'Y',

    },

    {
        materialName: "DoorsFrameMat",
        aOIntensity: 0.5007988329584008,
        envMapIntensity: 4.9,
        toneMapped: 'Y',

    },

    {
        materialName: "DoorsMat",
        aOIntensity: 0.5007988329584008,
        envMapIntensity: 4.372362539744721,
        toneMapped: 'Y',

    },

    {
        materialName: "CupboardMat",
        aOIntensity: 0.7243219908310835,
        envMapIntensity: 2.2861463995996822,
        toneMapped: 'Y',

    },

    {
        materialName: "SinkMat",
        aOIntensity: 1,
        envMapIntensity: 2.7331927153450475,
        toneMapped: 'N',

    },

    {
        materialName: "StoveMat",
        aOIntensity: 0.5007988329584008,
        envMapIntensity: 2.882208153926836,
        toneMapped: 'N',

    },

    {
        materialName: "OvenMat",
        aOIntensity: 1,
        envMapIntensity: 4.297854820453827,
        toneMapped: 'Y',

    },

    {
        materialName: "MicrowaveMat",
        aOIntensity: 1,
        envMapIntensity: 3.2547467503813072,
        toneMapped: 'N',

    },

    {
        materialName: "FrigeMat",
        aOIntensity: 0.7243219908310835,
        envMapIntensity:1.317546048818057,
        toneMapped: 'N',

    },

    {
        materialName: "KitchenTableMat",
        aOIntensity: 0.41,
        envMapIntensity: 3.18,
        toneMapped: 'Y',
    },

    {
        materialName: "ToiletPaperRollsMat",
        aOIntensity:0.41330714041680905,
        envMapIntensity:4.790826785104202,
        toneMapped: 'Y',

    },

    {
        materialName: "ToiletSeatMat",
        aOIntensity: 1,
        envMapIntensity: 2.3,
        toneMapped: 'Y',
    },

    {
        materialName: "ToiletPaperOnWall",
        aOIntensity:0.8396822685343355,
        envMapIntensity:4.255124701059105,
        toneMapped: 'Y',

    },

   /* {
        materialName:"ToiletPaperShelfMat",
        aOIntensity:1.0144492304476889,
        envMapIntensity:3.1910181341989503,
    },*/

    {
        materialName: "DFLT_CANVAS_MAT",
        toneMapped: 'N',
    },
    {
        materialName: "TableLampBigMat",
        aOIntensity: 0.4688669532623032,
        envMapIntensity: 2.435161838181471,
        toneMapped: 'N',

    },
    {
        materialName: "BigSofaMat",
        aOIntensity: 1,
        envMapIntensity: 3.0,
        toneMapped: 'Y',
    },
    {
        materialName: "FireplaceMat",
        aOIntensity: 0.6604582314388885,
        envMapIntensity: 4.7,
        toneMapped: 'Y',
    },
    {
        materialName: "BedSmallMat",
        aOIntensity: 0.66,
        envMapIntensity: 0.9,
        toneMapped: 'N',

    },
    {
        materialName: "Room01BedMat",
        aOIntensity: 0.47,
        envMapIntensity: 4.4,
        toneMapped: 'Y',
    },
    {
        materialName: "BedsideTableMat",
        aOIntensity: 0.8520495096154737,
        envMapIntensity: 3.403762188963096,
        toneMapped: 'Y',
    },
    {
        materialName: "TableLampRoom02Mat",
        aOIntensity: 0.3730713141740106,
        envMapIntensity: 2.8077004346359415,
        toneMapped: 'Y',

    },
    {
        materialName: "WardrobeMat",
        aOIntensity: 0.6604582314388885,
        envMapIntensity: 4.52137797832651,
        lightMapIntensity: 1,
        toneMapped: 'Y',
    },
    {
        materialName: "TableStudyRoomMat",
        aOIntensity: 0.24534379538962048,
        envMapIntensity: 1.6900846452725282,
        lightMapIntensity: 1,
        toneMapped: 'Y',

    },

    {
        materialName: "GroceriesMat",
        aOIntensity: 0.21341191569352294,
        envMapIntensity: 0.5724688559091144,
        lightMapIntensity: 1,
        toneMapped: 'N',

    },

    {
        materialName: "LampCeilingMat",
        aOIntensity: 1.5,
        envMapIntensity: 0.5724688559091144,
        toneMapped: 'N',

    },

    {
        materialName: "KettleMat",
        aOIntensity: 0.21341191569352294,
        envMapIntensity: 1.9881155224361051,
        toneMapped: 'Y',
    },

    {
        materialName: "TableTVLivingRoomMat",
        aOIntensity: 1,
        envMapIntensity: 1.5410692066907397,
    },
    {
        materialName: "ShelterWallMat",
        aOIntensity: 0.6285263517427909,
        envMapIntensity: 0.9450074523635857,
        toneMapped: 'Y',
    },
    {
        materialName: "ShelterCeilingMat",
        aOIntensity: 0.8,
        emmissiveIntensity: 1,
        envMapIntensity: 4.6,
        toneMapped: 'Y',
    },
    {
        materialName: "PaintingAssets01",
        toneMapped: 'N',
    },

    {
        materialName: "GardenMat",
        aOIntensity: 1.2033001862725463,
        envMapIntensity: 3.7763007854175665,
    },
    {
        materialName: "SoilMat",
        aOIntensity: 0.4688669532623032,
        envMapIntensity: 4.297854820453827,

    },

    {
        materialName: "DoorsHandleAndHingeMat",
        aOIntensity: 1,
        envMapIntensity: 6.682101837762443,
        roughness: 0.1,
        metalness: 1,

    },

    {
        materialName: "RoofMat",
        aOIntensity: 1,
        envMapIntensity: 2.4,
        toneMapped: 'Y',

    },

    {
        materialName: "StairsHandleMat",
        aOIntensity: 0.9159132690076687,
        envMapIntensity: 5.266455171235452,
        roughness: 0.2627285834077595,
        metalness: 1,
        toneMapped: 'Y',

    },

    {
        materialName: "Ball",
        aOIntensity: 1,
        envMapIntensity: 1.6900846452725282,
    },
    {
        materialName: "Treadmill",
        aOIntensity: 1.0117089080959614,
        envMapIntensity: 5.042932013362769,
    },


    {
        materialName: "OutsideWallsMat",
        aOIntensity: 0.7562538705271811,
        envMapIntensity: 1.01951517165448,
        toneMapped: 'N',

    },

    {
        materialName:"RollerBlindMat",
        aOIntensity:1.52,
        envMapIntensity:4.5,
        toneMapped:'Y',
    },

    {
        materialName: "BenchMat",
        aOIntensity: 1,
        envMapIntensity: 2.882208153926836,

    },


    {
        materialName: "KitchenIslandMat",
        aOIntensity: 0.5327307126544983,
        envMapIntensity: 0.9,
    },

    {
        materialName: "GatesMap",
        aOIntensity:0.9181410568322464,
        envMapIntensity:5.213489780123246,
    },

    {
        materialName:"KitchenExtractorMat",
        aOIntensity:0.5485881223516949,
        envMapIntensity:3.1783440368997176,

    },
    {
        materialName:"RemoteControlMat",
        aOIntensity:0.5008056378319949,
        envMapIntensity:0.4,
        toneMapped:'N',

    },

    {
        materialName:"LaptopMat",
        aOIntensity:0.5971138114474376,
        envMapIntensity:2.6666736334037626,
    },

    {
        materialName:"Farm Tools",
        aOIntensity:0.9502437813707272,
        envMapIntensity:2.516860918890852,
    },

    {
        materialName:"LOCKDOWN_UV_V01",
        toneMapped: 'N',
    },

    {
        materialName:"LOCKDOWN_UV_V02",
        toneMapped: 'N',
    },

    {
        materialName:"LOCKDOWN_UV_V04",
        toneMapped: 'N',
    },

    {
        materialName:"ClosedDoorsMat",
        aOIntensity:0.6934219850628802,
        envMapIntensity:1.3183592027875657,
        toneMapped:'N',
    },
    {
        materialName:"VisitorsBookMat",
        aOIntensity:0.8,
        envMapIntensity:5.8,
        toneMapped:'Y',
    },

    {
        materialName:"bagMat",
        aOIntensity:1.397249743764947,
        envMapIntensity:3.872480355312607,
    },
    {
        materialName:"PlasticBoxMat",
        toneMapped:'N'
    },
    {
        materialName:"HouseSignMat",
        toneMapped:'N'
    },
    {
        materialName: "HeadPhoneMat",
        aOIntensity: 0.5650110869089567,
        envMapIntensity: 3.1910181341989503,
    },

    {
        materialName:"ChairKitchenMat",
        aOIntensity:0.7084899214212504,
        envMapIntensity:2.1123163648787155,

    },

    {
        materialName:"ToiletPaperShelfMat",
        aOIntensity:1.1020669627605055,
        envMapIntensity:4.331653570208405,
    },

    {
        materialName:"CharKitchenV21Mat",
        aOIntensity:1.0144492304476889,
        envMapIntensity:0.419482915710101,
        toneMapped:'N',
    },

    {
        materialName:"BreadMat",
        aOIntensity:0.43660018875503326,
        envMapIntensity:3.340830848711861,
    },

]

/*

[
[
{
 materialName:"FloorFirstMat",
aOIntensity:0.2760865660626288,
envMapIntensity:2.591767276147307,
roughness:0.7233824379443335,
 },

 ]

 ]

 */
